import { apiEndPoint } from "./endPoint";

export const deleteNotificationDataById = async (
  userId: string,
  token: string
) => {
  const url = `${apiEndPoint}/deleteNotificationData/${userId}`;

  try {
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    console.log(response);

    if (response.ok) {
      const responseData = await response.json();
      console.log(responseData);
      return { ...responseData, status: 200 };
    } else {
      throw new Error("Failed to fetch");
    }
  } catch (err) {
    console.error("Error:", err);
    return "エラーが発生しました: ${err.message}";
  }
};
